import firebase from "firebase/app";
import FirestoreService from "./FirestoreService";

export default class PostService {

    static listenToPost(uid, callback) {
        FirestoreService.firestoreDB()
            .collection("posts")
            .doc(uid)
            .onSnapshot(
            doc => {
                callback(null, doc.data());
                //console.log("Current data: ", doc && doc.data());
            },
            function (err) {
                callback(err);
            }
            );
    }

    static getPost(id) {
        return FirestoreService.firestoreDB().collection('posts').doc(id).get();
    }

    static getFilteredPosts(filters) {
        let query = FirestoreService.firestoreDB().collection('posts');

        if (filters.status !== 'Any') {
            query = query.where('status', '==', filters.status);
        }

        if (filters.type !== 'Any') {
            query = query.where('type', '==', filters.type);
        }

        query = query.orderBy('timestamp', 'desc');

        this.getDocumentsInQuery(query);
    }

    static getAllPosts(callback) {
        const collectionRef = FirestoreService.firestoreDB().collection('posts');
        const query = collectionRef.orderBy('lastchangeddatetime', 'desc').limit(50);
        this.getDocumentsInQuery(query, callback, collectionRef);
    }

    static getAllPostMessages(collectionRef, postId, callback) {
        let subCollectionDocs = collectionRef.doc(postId).collection("messages");
        const query = subCollectionDocs.orderBy('createddatetime', 'desc');
        this.getDocumentsInQuery(query, callback, subCollectionDocs);
    }


    static getDocumentsInQuery(query, callback, collectionRef) {
        query.onSnapshot(snapshot => {
            if (!snapshot.size) return;

            callback(snapshot, collectionRef);

        });
    }

    static updatePost(post, changeDateModified) {
        if (!post || !post.id) {
            throw new Error("Post Id is required for the update");            
        }

        if (changeDateModified === undefined) {
            changeDateModified = true;
        }           

        const postRef = FirestoreService.firestoreDB()
            .collection("posts")
            .doc(post.id);

        var postData = {
            title: post.title,
            status: post.status,
            type: post.type,
            clusters: FirestoreService.ArrayToObject(post.clusters),
            description: post.description,
            lastchangeduserid: firebase.auth().currentUser.uid,
            lastchangeddatetime: post.lastchangeddatetime,
            expiry: post.expiry
        };

        if (changeDateModified) {
            postData.lastchangeddatetime = FirestoreService.timestamp();
        }        

        postRef.update(postData).catch(function (error) {
            console.error("Error updating post: ", error);
            alert("Cannot update a post\r\n" + error.message);
        });
    }


    static deletePost(post) {
        if (!post || !post.id) {
            throw new Error("Post Id is required for the delete action");
        }
        FirestoreService.deleteDocument('posts', post.id);
    }

    static createPost(post, callback) {
        if (!post) {
            return;
        }

        const timestamp = FirestoreService.timestamp();
        const postData = {
            //            id: post.id,
            title: post.title,
            status: post.status,
            type: post.type,
            clusters: FirestoreService.ArrayToObject(post.clusters),
            description: post.description,
            createduserid: firebase.auth().currentUser.uid,
            lastchangeduserid: firebase.auth().currentUser.uid,
            lastchangeddatetime: timestamp,
            createddatetime: timestamp,
            expiry: post.expiry
        };

        FirestoreService.firestoreDB()
            .collection("posts")
            .add(postData)
            .then(docRef => {
                console.log("Document written with ID: ", docRef.id);
                post.id = docRef.id;
                callback(post);
            })
            .catch(function (error) {
                console.error("Error adding document: ", error);
                alert("Cannot create a post\r\n" + error.message);
            });
    }

    static createPostMessage(postmessage, callback) {

        if (!postmessage || !postmessage.postid) {
            return;
        }

        const timestamp = FirestoreService.timestamp();

        const messageData = {
            status: postmessage.status,
            text: postmessage.text,
            createddatetime: timestamp,
            createduserid: firebase.auth().currentUser.uid,
        };

        FirestoreService.firestoreDB()
            .collection("posts").doc(postmessage.postid)
            .collection("messages")
            .add(messageData)
            .then(docRef => {
                postmessage.id = docRef.id;
                callback(postmessage);
            })
            .catch(function (error) {
                console.error("Error adding document: ", error);
                alert("Cannot create the post message\r\n" + error.message);
            });


    }

    //static deletePostMessage(postMessage) {
    //    if (!postmessage || !postmessage.postid || !postmessage.id) {
    //            throw new Error("Post Message requires postid and id for the delete action");
    //    }
    //    const postRef = FirestoreService.firestoreDB().collection("posts").get(postMessage.postid);
    //    FirestoreService.deleteDocument('messages', postMessage.id, postRef);
    //}


    static deletePostMessage(message, callback) {
        if (!message || !message.postid || !message.id) {
            throw new Error("Post Message requires postid and id for the delete action");
        }

        const postMessageRef = FirestoreService.firestoreDB()
            .collection("posts").doc(message.postid)
            .collection("messages")
            .doc(message.id);

        postMessageRef.delete().then(callback);
    }
}



// WEBPACK FOOTER //
// ./src/service/PostService.js